import React from 'react';
import { useIntl } from 'react-intl';
import LogoResizer from '@gin-betting/components/logo-resizer';
import { App } from '@gin-betting/core';
import cn from 'classnames';

import globalMessages from 'messages';
import UserDevice from 'services/user-device';
import { ParentPath } from 'types';
import BackButton from '../BackButton';
import SmartLink from '../SmartLink';

import './eventInfo.scss';

interface Props {
    hasBackButton: boolean;
    isInverted?: boolean;
    logo: string;
    slug: string;
    name: string;
    date?: string;
    route?: ParentPath;
    description?: string;
    prizePool?: string;
}

const EventInfo: React.FC<Props> = ({
    hasBackButton,
    prizePool,
    isInverted,
    logo,
    slug,
    date,
    name,
    route,
    description,
}) => {
    const { formatMessage } = useIntl();

    const isMobile = UserDevice.getInstance()?.isDeviceMobile();

    return (
        <div styleName="container" className="__app-EventInfo-container">
            {hasBackButton && !isMobile && <BackButton />}

            <div
                styleName={cn('wrapper', {
                    'is-inverted': isInverted,
                })}
                className="__app-EventInfo-wrapper"
            >
                <LogoResizer url={logo} isOutsource={true}>
                    {({ ref, url }) => (
                        <img
                            styleName={cn('logo', {
                                'is-loaded': !!url,
                            })}
                            ref={ref}
                            alt={slug}
                            src={url}
                        />
                    )}
                </LogoResizer>

                <div styleName="info-wrap">
                    {date && <p styleName="title">{date}</p>}

                    <h1 styleName="h1">
                        {route ? (
                            <SmartLink
                                to={`${route}${App.Routes.TOURNAMENT}${slug}`}
                                styleName="name"
                            >
                                {name}
                            </SmartLink>
                        ) : (
                            <span styleName="name">{name}</span>
                        )}
                    </h1>

                    {description && !isMobile && (
                        <p styleName="description">{description}</p>
                    )}
                </div>

                {prizePool && (
                    <div styleName="prize-wrap">
                        <p styleName="title">
                            {formatMessage(globalMessages.prizePool)}
                        </p>
                        <p styleName="prize-pool">{prizePool}</p>
                    </div>
                )}
            </div>
            {description && isMobile && (
                <p styleName="description">{description}</p>
            )}
        </div>
    );
};

export default React.memo(EventInfo);
